export const disableDates = {
    disableDates(evt: Date): boolean {
        return evt < new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    }
}